import * as React from "react"

import useStatefulField from "shared/hooks/useStatefulField"

import { BaseCellProps } from "../shared/BaseCell"

import { Checkbox, StyledCell } from "./Styles"

export interface CheckboxCellProps extends BaseCellProps {
  initialValue: boolean
  onChange: (value: boolean) => void
  hideCheckbox?: boolean
}

const CheckboxCell = ({
  initialValue,
  onChange,
  hideCheckbox = false,
  ...cellProps
}: CheckboxCellProps): JSX.Element => {
  const { value, handleChange } = useStatefulField({ initialValue, onChange, debounce: false })

  const $checkboxRef = React.useRef<HTMLInputElement>(null)

  const cellClicked = (event: React.MouseEvent<HTMLDivElement>): void => {
    const checkbox = $checkboxRef.current
    if (checkbox && event.target !== checkbox) {
      checkbox.checked = !checkbox.checked
      handleChange(checkbox.checked)
      checkbox.focus()
    }
  }

  return (
    <StyledCell onClick={cellClicked} {...cellProps}>
      {!hideCheckbox && (
        <Checkbox
          ref={$checkboxRef}
          checked={value}
          onChange={(event) => handleChange(event.target.checked)}
          onClick={() => $checkboxRef.current?.focus()}
        />
      )}
    </StyledCell>
  )
}

export default CheckboxCell
